import { AppConstants } from "@/common";
import type { Channels, Channel, ChannelsData } from "@ca.vmedia.tv/domains";
import type { ExposeInterface } from './types';
import type { AxiosError } from "axios";

export const useChannelsStore = defineStore('Channels', (): ExposeInterface => {
    const { $services } = useNuxtApp();

    const _availableChannels: Ref<Channels | null> = ref(null);
    const getAvailableChannels: ComputedRef<Channel[]> = computed(() => [..._availableChannels.value?.items ?? []]);

    const _notAvailableChannels: Ref<Channels | null> = ref(null);
    const getNotAvailableChannels: ComputedRef<Channel[]> = computed(() => [..._notAvailableChannels.value?.items ?? []]);

    const _outOfHomeChannels: Ref<Channels | null> = ref(null);
    const getOutOfHomeChannels: ComputedRef<Channel[]> = computed(() => [..._outOfHomeChannels.value?.items ?? []]);

    const getChannelById = (id: number): Channel[] => [..._availableChannels.value?.items ?? []].filter(channel => channel.id && channel.id === id);

    const getFilteredChannels = (query: string): Channel[] => {
        if (!query) {
            return [];
        }
        const queryLc = query.toLowerCase();
        return [..._availableChannels.value?.items ?? []]
            .filter(channel => channel.id && ((channel.name && channel.name.toLowerCase().includes(queryLc)) 
            || (channel.accessNum && channel.accessNum.toString().includes(queryLc))
            || (channel.callSign && channel.callSign.toLowerCase().includes(queryLc))));
    };

    const setChannelsData = (channelsData: ChannelsData): void => {
        _availableChannels.value = channelsData.availableChannels;
        _notAvailableChannels.value = channelsData.notAvailableChannels;
        _outOfHomeChannels.value = channelsData.outOfHomeChannels;
    };

    const getChannels = async (): Promise<void> => {
        try {
            const channelsData = await $services.channels.loadChannels(1, AppConstants.TotalItems);
            setChannelsData(channelsData);
        } catch (error) {
            Logger.captureError(error as Error | AxiosError);
        }
    };

    return {
        getAvailableChannels,
        getNotAvailableChannels,
        getOutOfHomeChannels,
        getChannelById,
        getFilteredChannels,
        setChannelsData,
        getChannels,
    };
});